'use client'

import { Box, Paper, Typography } from '@mui/material'
import type { JSX } from 'react'
import { ReactElement } from 'react'
import { tss } from 'tss-react/mui'
import { QuoteIcon } from '../Icon/catalog'

const useStyles = tss.create(({ theme }) => ({
    card: {
        background: 'rgba(30, 112, 161, 0.04)',
        width: '100%',
        padding: theme.spacing(2),
    },
    cardVariation: {
        display: ' flex',
    },
    quoteContainer: {
        display: 'flex',
    },
    quote: {
        marginRight: theme.spacing(2),
        color: 'rgba(30, 112, 161, 0.5)',
    },
    quoteVariation: {
        marginRight: theme.spacing(1),
        color: 'rgba(30, 112, 161, 0.5)',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    avatarContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    userText: {
        textAlign: 'center',
        marginTop: theme.spacing(1),
    },
    testimonialText: {
        fontWeight: 'normal',
        marginBottom: theme.spacing(1),
        letterSpacing: '-0.31px',
    },
    avatarWrapper: {
        marginRight: theme.spacing(2),
    },
    caption: {
        marginLeft: theme.spacing(1),
    },
}))

export type ReviewExcerptProps = {
    testimonial: string
    avatar: ReactElement
    membershipDetails?: string
    firstName?: string
}

const ReviewExcerpt = ({ testimonial, avatar, membershipDetails, firstName }: ReviewExcerptProps): JSX.Element => {
    const { classes, cx } = useStyles()
    return (
        <Paper className={cx(classes.card, firstName && classes.cardVariation)}>
            {firstName ? (
                <Box className={classes.avatarWrapper}>
                    {avatar}
                    <Typography variant="subtitle2" className={classes.userText}>
                        {firstName}
                    </Typography>
                </Box>
            ) : null}
            <Box className={classes.quoteContainer}>
                <QuoteIcon className={cx(firstName ? classes.quoteVariation : classes.quote)} />
                <Box className={classes.textContainer}>
                    <Typography variant="h3" className={classes.testimonialText}>
                        {testimonial}
                    </Typography>
                    {membershipDetails ? (
                        <Box className={classes.avatarContainer}>
                            {avatar}
                            <Typography variant="caption" className={classes.caption}>
                                {membershipDetails}
                            </Typography>
                        </Box>
                    ) : null}
                </Box>
            </Box>
        </Paper>
    )
}

export default ReviewExcerpt
